// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.modalGameOver {
  color: white;
}
.modal.modalGameOver .illustration {
  margin-bottom: 25px;
  border-radius: 10px;
}
.modal.modalGameOver .illustration img {
  width: 150px;
  border-radius: 10px;
  -webkit-filter: invert(1) drop-shadow(1px 5px 5px rgba(0, 0, 0, 0.25));
          filter: invert(1) drop-shadow(1px 5px 5px rgba(0, 0, 0, 0.25));
}
.modal.modalGameOver.blue .body {
  background: #382491;
}
.modal.modalGameOver.red .body {
  background: linear-gradient(16deg, #c92a2a, #600e0e);
}
.modal.modalGameOver.red.winner .body {
  background-image: linear-gradient(16deg, #c92a2a, #e14d4d);
}
.modal.modalGameOver.green .body {
  background: #1e7033;
  background-image: linear-gradient(16deg, #217737, #144120);
}
.modal.modalGameOver.green.winner .body {
  background-image: linear-gradient(16deg, #217737, #2fba54);
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modalGameover.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,YAAA;EACA,mBAAA;EACA,sEAAA;UAAA,8DAAA;AACN;AAGE;EACE,mBAAA;AADJ;AAKI;EACE,oDAAA;AAHN;AAMI;EACE,0DAAA;AAJN;AASI;EACE,mBAAA;EACA,0DAAA;AAPN;AAUI;EACE,0DAAA;AARN","sourcesContent":[".modal.modalGameOver {\n  color: white;\n\n  .illustration {\n    margin-bottom: 25px;\n    border-radius: 10px;\n\n    img {\n      width: 150px;\n      border-radius: 10px;\n      filter: invert(1) drop-shadow(1px 5px 5px rgba(0, 0, 0, 0.25));\n    }\n  }\n\n  &.blue .body {\n    background: #382491;\n  }\n\n  &.red {\n    .body {\n      background: linear-gradient(16deg, #c92a2a, #600e0e);\n    }\n\n    &.winner .body {\n      background-image: linear-gradient(16deg, #c92a2a, #e14d4d);\n    }\n  }\n\n  &.green {\n    .body {\n      background: #1e7033;\n      background-image: linear-gradient(16deg, #217737, #144120);\n    }\n\n    &.winner .body {\n      background-image: linear-gradient(16deg, #217737, #2fba54);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
